import {BusinessProductUpdateCategory, BusinessUpdateStatus} from '@/types';

// Mirrors the Business Portal's own category colors; kept as a separate copy since the two packages share no component layer.
export const CATEGORY_STYLES: Record<
  BusinessProductUpdateCategory,
  {label: string; className: string}
> = {
  [BusinessProductUpdateCategory.Portal]: {
    label: 'Portal',
    className: 'bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-300',
  },
  [BusinessProductUpdateCategory.Api]: {
    label: 'API',
    className:
      'bg-purple-100 text-purple-600 dark:bg-purple-900 dark:text-purple-300',
  },
  [BusinessProductUpdateCategory.General]: {
    label: 'General',
    className: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
  },
};

export const STATUS_STYLES: Record<
  BusinessUpdateStatus,
  {label: string; className: string; dotClassName: string}
> = {
  [BusinessUpdateStatus.Published]: {
    label: 'Published',
    className: 'text-green-600 dark:text-green-400',
    dotClassName: 'bg-green-500',
  },
  [BusinessUpdateStatus.Scheduled]: {
    label: 'Scheduled',
    className: 'text-yellow-600 dark:text-yellow-400',
    dotClassName: 'bg-yellow-500',
  },
  [BusinessUpdateStatus.Draft]: {
    label: 'Draft',
    className: 'text-gray-500 dark:text-gray-400',
    dotClassName: 'bg-gray-400',
  },
  [BusinessUpdateStatus.Unpublished]: {
    label: 'Unpublished',
    className: 'text-gray-500 dark:text-gray-400',
    dotClassName: 'bg-gray-400',
  },
};
